<template>
  <div>
    <div class="text-center mt-6" v-if="!dataLoaded">
      <v-progress-circular :size="50" color="primary" indeterminate />
    </div>

    <div v-show="dataLoaded">
      <v-row class="my-0">
        <v-col cols="12" class="pt-0">
          <v-card class="base-card pa-5" ref="paramsBlock">
            <v-btn
              text
              @click="getReport"
              :disabled="disableReportBtn"
              color="accent"
              class="print-btn px-1"
              title="Сформировать отчет"
              :loading="loading"
              :ripple="false"
            >
              <v-icon left class="file-icon mr-0" size="20">mdi-printer-outline</v-icon>
              <span class="ml-2">Сформировать отчет</span>
            </v-btn>
            <div class="inputs">
              <v-autocomplete
                v-model="reportType"
                class="mt-4"
                label="Тип отчета"
                placeholder="Выберите значение из списка"
                :items="finalReportList"
                item-text="name"
                hide-no-data
                return-object
                clearable
                :disabled="loading"
              />

              <div class="dates mt-1">
                <div class="date">
                  <DatePicker
                    :disabled="loading"
                    :date="fromDate"
                    label="Дата c"
                    @setDate="fromDate = $event"
                  />
                </div>

                <div class="date ml-5">
                  <DatePicker
                    :disabled="loading"
                    :date="toDate"
                    label="Дата по"
                    @setDate="toDate = $event"
                  />
                </div>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { reportApi } from '@/api'
import download from '@/plugins/download'
import DatePicker from '@/components/ui/DatePicker'

export default {
  name: 'FinalReports',

  metaInfo: {
    title: 'Отчеты',
  },

  components: {
    DatePicker,
  },

  async created() {
    this.dataLoaded = true
  },

  data: () => ({
    reportApi,
    dataLoaded: false,
    loading: false,
    reportBtn: false,
    finalReportList: [
      {
        name: 'Повышение квалификации',
        value: 'dpoQualificationReport',
      },
      {
        name: 'Переподготовка',
        value: 'dpoRequalificationReport',
      },

      {
        name: 'Справка',
        value: 'dpoQualificationReportReference',
      },
    ],
    reportName: null,
    reportType: null,
    fromDate: null,
    toDate: null,
  }),

  computed: {
    disableReportBtn() {
      return !(this.reportType && this.fromDate && this.toDate)
    },
  },

  methods: {
    parseDate(date) {
      const [yy, mm, dd] = date.split('-')
      return `${dd}${mm}${yy}`
    },
    async getReport() {
      this.loading = true
      const params = {
        fromDate: this.fromDate || null,
        toDate: this.toDate || null,
      }

      let data

      try {
        if (this.reportType) {
          if (this.reportType.value == 'dpoQualificationReportReference') {
            this.reportName = `Справка_${this.parseDate(params.fromDate)}_${this.parseDate(
              params.toDate
            )}`

            data = await this.reportApi.getDpoQualificationReport(params)
          }
          if (this.reportType.value == 'dpoRequalificationReport') {
            this.reportName = `Переподготовка_${this.parseDate(params.fromDate)}_${this.parseDate(
              params.toDate
            )}`

            data = await this.reportApi.getDpoRequalificationReport(params)
          }

          if (this.reportType.value == 'dpoQualificationReport') {
            this.reportName = `Повышение квалификации_${this.parseDate(
              params.fromDate
            )}_${this.parseDate(params.toDate)}`
            data = await this.reportApi.getDpoQualificationReportReference(params)
          }

          data && download(data, `${this.reportName}.xlsx`)
        }
      } catch (error) {
        this.$toastr('warning', '', 'Не удалось софрмировать отчет')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.base-card .inputs {
  max-width: 600px;
}

.dates {
  display: flex;
}

.date {
  width: 50%;
}
</style>
